"use client"

import ProductColorButton from "@/components/common/ProductColorButton"
import ProductLabel from "@/components/common/ProductLabel"
import { useSelectedVariant } from "@/hooks/product_no_design/useSelectedVariant"
import { useAppDispatch, useAppSelector } from "@/hooks/redux"
import { productActions } from "@/lib/redux/features/product/reduce"
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Col, ConfigProvider, Row, Tooltip, Typography } from "antd"

const ProductColors = () => {
  const attributes = useAppSelector(state => state.product.product_no_design?.data?.attributes)
  const variants = useAppSelector(state => state.product.product_no_design?.data?.variants)
  const selectedVariant = useSelectedVariant()
  const dispatch = useAppDispatch()
  const colorsSelectionSetting = useAppSelector(state => state.store.store_setting.data.colors_selection)

  if (!attributes || !attributes?.find(attr => !!attr['color'])) {
    return <></>
  }

  const collectionColors = variants?.reduce((arr: any[], v) => {
    const attributes = v.attributes || []
    for (let i = 0; i < attributes.length; i++) {
      const attr = attributes[i];
      if (!attr.color) {
        continue
      }
      if (!arr.some((a: any) => a.color === attr.color)) {
        arr.push(attr)
      }
    }
    return arr
  }, []) || []

  return (
    <>
      <Row>
        <ProductLabel labelSetting={colorsSelectionSetting.label} />
      </Row>
      <Row gutter={[10, 10]}>
        {collectionColors.map((attr) => {
          const color = attr.color
          const isNotTexture = attr.values?.texture === "null" || !attr.values?.texture
          const isWhite = attr.values?.color === "White" || attr.values?.color.toLowerCase() === "#ffffff"
          // const variants = variantsMapping[color.id] || []

          return (
            <Col key={attr.color}>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: isWhite ? "#e1e2e7" : attr.values?.color
                  },
                  components: {
                    Button: {
                      controlOutlineWidth: 0
                    }
                  }
                }}
              >
                <Tooltip
                  title={attr.color}
                >
                  <ProductColorButton
                    aria-label={`Color option ${attr.color}`}
                    onClick={() => dispatch(productActions.selectVariantNoDesign({
                      type: "color",
                      value: isNotTexture ? attr.values?.color : attr.values?.texture
                    }))}
                    icon={variants?.some(v => v.attributes?.some(attr1 => attr1?.color === attr.color) && v.id === selectedVariant.id) ? <FontAwesomeIcon icon={faCheck} /> : undefined}
                    style={{
                      ...(!isNotTexture ? { background: `url("${attr.values.texture}")` } : {})
                    }}
                  />
                </Tooltip>
              </ConfigProvider>
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default ProductColors